import React from "react";

interface IQuickAddTrackingEventsContext {
  onQuickAddButtonClick?: (newQuantity?: number) => void;
  onQuickAddSubmit?: (newQuantity?: number) => void;
  onChooseOptionClick?: () => void;
  onChooseOptionQuantityUpdateSubmit?: (newQuantity?: number) => void;
  getCartItemTokenByProductToken?: (productToken: string) => void;
}

export const QuickAddTrackingEventsContext =
  React.createContext<IQuickAddTrackingEventsContext>({});
